import { isString } from 'util';

export class ErrorUtils {
  public static getErrorMessage(error: any): string {
    if (isString(error.error)) {
      return error.error;
    }
    if (error.error && error.error.errorMessage) {
      return error.error.errorMessage;
    }
    return 'Wystąpił nieznany błąd.';
  }
}



// WEBPACK FOOTER //
// ./src/utils/error.utils.ts